import store from "@/store/index.js";

export function showProgressGif(msg) {
   store.commit("app/showProgressGifMsg", msg);
}

export function hideProgressGif() {
   store.commit("app/hideProgressGif");
}
